import { Component, OnInit } from '@angular/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { MinuteService } from '../../service/minute/minute.service';
import { Minute } from '../../class/minute';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule, SelectItem } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { config } from '../../../../../environments/config';
import { formatDate } from '../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../theme/functions/calendarES';

@Component({
  selector: 'app-minutes',
  templateUrl: './minutes.component.html',
  styleUrls: ['./minutes.component.scss']
})
export class MinutesComponent implements OnInit {

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public minutes: Minute[];
    public selectMinute: Minute;
    public MinuteID: Number = 0;
    public modNew = false;
    public modView = false;
    public openMinute = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;

    public filters: any[];
    public first = 0;

    public form3: FormGroup;
    public employee_id_filter: AbstractControl;
    public type_filter: AbstractControl;
    public typeOptions: SelectItem[];

    public form4: FormGroup;
    public f4_date_start: AbstractControl;
    public f4_date_end: AbstractControl;
    public f4_employee_id: AbstractControl;
    public f4_type_filter: AbstractControl;
    public f4_export_filter: AbstractControl;

    public apiUrl = config.API_ROOT;

    public modExportDialog: boolean;

    public es: any;

    public exportOptions: SelectItem[];

    constructor(
        public minuteService: MinuteService,
        public hasPermissionService: HasPermissionService,
        public confirmationService: ConfirmationService,
        public translate: TranslateService,
        fb: FormBuilder) {
            this.exportOptions = [
                {label: 'Excel', value: 'excel'},
            ];

            this.es = calendarES();

            this.typeOptions = [
                {label: 'Todas', value: 'all'},
                {label: 'Novedad', value: 'Novedad'},
                {label: 'Tarea', value: 'Tarea'},
                {label: 'Trámite', value: 'Trámite'},
                {label: 'Nota', value: 'Nota'},
            ];

            this.form3 = fb.group({
                'employee_id_filter': [''],
                'type_filter': ['']
            });
            this.employee_id_filter = this.form3.controls['employee_id_filter'];
            this.type_filter = this.form3.controls['type_filter'];
            this.type_filter.setValue('all');

            this.form4 = fb.group({
                'f4_date_start': ['', [Validators.required]],
                'f4_date_end': ['', [Validators.required]],
                'f4_employee_id': [''],
                'f4_type_filter': [''],
                'f4_export_filter': [''],
            });
            this.f4_date_start = this.form4.controls['f4_date_start'];
            this.f4_date_end = this.form4.controls['f4_date_end'];
            this.f4_employee_id = this.form4.controls['f4_employee_id'];
            this.f4_export_filter = this.form4.controls['f4_export_filter'];
            this.f4_type_filter = this.form4.controls['f4_type_filter'];
            this.f4_type_filter.setValue('all');
            this.f4_export_filter.setValue('excel');

            this.modExportDialog = false;
        }

    ngOnInit() {
        //this.getOpeningsStation();
        this.page = 1;
        this.per_page = 10;
        // this.sort = '-id';
    }

    public loadMinutesLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  event.sortField;
        } else {
            this.sort =  '-id';
        }

        if (event.globalFilter) {
            this.query = event.globalFilter;
        } else {
            this.query = undefined;
        }

        this.getOpeningsStation(event.globalFilter);
    }

    public getOpeningsStation(query?: string, filtersReceived?: any[]) {
        const filters = [];
        if (filtersReceived) {
            filtersReceived.forEach(element => {
                if (element.value) {
                    filters.push({'key': element.key, 'value': element.value});
                }
            });
        }

        this.minuteService.getMinute(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                this.minutes = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newMinute() {
        this.modNew = !this.modNew;
        this.selectMinute = null;
    }

    public savedMinute(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectMinute = null;
        this.modNew = false;
        this.getOpeningsStation();
    }

    public cancelMinute (res) {
        this.selectMinute = null;
        this.modNew = false;
        this.modView = false;
        this.getOpeningsStation();
    }

    public edit(minute: Minute) {
        this.modNew = true;
        this.selectMinute = minute;
        this.getOpeningsStation();
    }

    public view(minute: Minute) {
        this.openMinute = true;
        this.selectMinute = minute;
        this.MinuteID = minute.id;
        this.modView = true;
    }

    public deleteDialog(minute: Minute) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(minute);
            }
        });
    }

    public delete(minute: Minute) {
        this.minuteService.deleteMinute(minute.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getOpeningsStation();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeMinute(minute: Minute) {
        this.putMinute(minute);
    }

    public putMinute(values: Minute) {
        const param = {
            'description': values.description,
            'type': values.type,
            'status': values.status,
        };
        if (values) {
            const promise = this.minuteService.updateMinute(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public filterStation (values) {
        this.page = 1;
        this.first = 0;

        this.filters = [];
        if (values.employee_id_filter) {
            this.filters.push({'key': 'user_id-lk', 'value': values.employee_id_filter.user.id});
        }
        if (values.type_filter !== 'all' && values.type_filter !== '') {
            this.filters.push({'key': 'type-lk', 'value': values.type_filter});
        }
        this.getOpeningsStation(undefined, this.filters);
    }

    public changeStatus(minute: Minute, value?) {
        minute.status = value;
        this.putMinute(minute);
    }

    public showExportDialog() {
        this.modExportDialog = true;
    }

    public cancelExport() {
        this.modExportDialog = false;
    }

    public exportReportPdf(values) {
        let d = new Date(values.f4_date_start);
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);

        const f4_date_start = formatDate(d);

        d = new Date(values.f4_date_end);
        d.setHours(23);
        d.setMinutes(59);
        d.setSeconds(59);
        d.setMilliseconds(59);
        const f4_date_end = formatDate(d);

        window.open(this.apiUrl + '/minutes/pdf?created_at-min=' + f4_date_start + '&created_at-max=' + f4_date_end +
        '&token=' + localStorage.getItem('token') + '&_page=1&_limit=100000', '_blank');
    }

    public exportReport(values) {
        if (values.f4_export_filter === 'pdf') {
            this.exportReportPdf(values);
        } else {
            this.exportReportExcel(values);
        }
    }

    public exportReportExcel(values) {
        let d = new Date(values.f4_date_start);
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);

        const f4_date_start = formatDate(d);

        d = new Date(values.f4_date_end);
        d.setHours(23);
        d.setMinutes(59);
        d.setSeconds(59);
        d.setMilliseconds(59);
        const f4_date_end = formatDate(d);

        let url = this.apiUrl + '/minutes/excel?' +
        'token=' + localStorage.getItem('token') +
        '&_page=1&_limit=100000&_sort=-id&';

        if (f4_date_start) {
            url = url + 'created_at-min=' + f4_date_start + '&';
        }

        if (f4_date_end) {
            url = url + 'created_at-max=' + f4_date_end + '&';
        }

        if (values.f4_employee_id) {
            url = url + 'user_id-in=' + values.f4_employee_id.id + '&';
        }

        if (values.f4_type_filter !== 'all' && values.f4_type_filter !== '') {
            url = url + 'type-in=' + values.f4_type_filter + '&';
        }

        window.open(url, '_blank');
    }    
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/minutes/minutes.component.ts